import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import { Link as RebassLink, Box } from "rebass";
import { slide as Menu } from "react-burger-menu";
import Img from "react-image";

import { metaDataProps } from "../../pages/index";
import FacebookButton from "../ui/FacebookButton";
import { navLinks } from "../Navbar";
import logoWhite from "../../img/logo-white.png";
import "./mobile-nav.css";
import Circle from "../../components/ui/Circle";
import messengerLogo from "../../img/facebook-messenger.svg";

type Props = {
  siteMetadata: metaDataProps,
  user: { demoLinkRef: string }
};

class MobileNav extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {
      menuActive: false
    };
  }

  toggleMenu = (toggle: boolean) => {
    this.setState({
      menuActive: toggle
    });
  };

  render() {
    const { user } = this.props;
    return (
      <MenuWrap ml="auto">
        {this.props.user && (
          <Box mr="30px">
            <DemoLink href={user.demoLink} target="_blank">
              <StyledMessengerLogo src={messengerLogo} alt="Messenger Logo" />{" "}
              Demo
            </DemoLink>
          </Box>
        )}

        <Menu isOpen={this.state.menuActive} right width="280px">
          <img src={logoWhite} alt="Pipeline Logo" height="27" />

          <StyledLink to="/" color="white" is={Link} mt="15px" mb="10px">
            Home
          </StyledLink>
          {navLinks.map((link, i) => (
            <StyledLink
              key={i}
              to={link.path}
              color="white"
              is={Link}
              mb="10px"
            >
              {link.label}
            </StyledLink>
          ))}

          <StyledFacebookButton is="a" href={this.props.siteMetadata.appUrl}>
            Login with Facebook
          </StyledFacebookButton>

          <div className="fb-plugin">
            <div
              className="fb-messengermessageus"
              messenger_app_id="137853846788998"
              page_id="227754084405138"
              color="blue"
              data-size="xlarge"
            />
          </div>

          <Circle1 r={40} />
          <Circle2 r={100} />
          <Circle3 r={6} />
        </Menu>
      </MenuWrap>
    );
  }
}

export default MobileNav;

// Styled Components
const MenuWrap = styled(Box)`
  @media (min-width: 48em) {
    display: none;
  }
`;

const StyledFacebookButton = styled(FacebookButton)`
  color: #fff !important;
  display: inline-block !important;
  font-size: 14px;
  font-weight: 400;
  margin: 15px 0;
  padding: 12px 11px 11px;
  text-align: left;
`;

const StyledLink = styled(RebassLink)`
  color: #fff;
  font-size: 15px;
  text-decoration: none;

  &:visited,
  &:active {
    color: #fff;
  }
`;

const Circle1 = styled(Circle)`
  opacity: 0.3;
  position: absolute;
  right: -30px;
  top: -30px;
`;

const Circle2 = styled(Circle)`
  opacity: 0.3;
  position: absolute;
  left: -90px;
  bottom: -90px;
`;

const Circle3 = styled(Circle)`
  opacity: 0.2;
  position: absolute;
  left: 150px;
  top: 60px;
`;

const DemoLink = styled.a`
  font-size: 14px;
  text-decoration: none;
`;

const StyledMessengerLogo = styled(Img)`
  height: 13px;
  position: relative;
  top: 2px;
`;



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNav.jsx